/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Reset_Panel_Aria_LabelInputs */

const en_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Panel`)
};

const fr_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinitialiser le panneau`)
};

const de_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset-Panel`)
};

const it_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pannello di ripristino`)
};

const ru_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель сброса`)
};

const es_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de reinicio`)
};

const zh_cn2_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置面板`)
};

const ja_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パネルをリセット`)
};

const hi_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रीसेट पैनल`)
};

const pt_pt2_style_guide_reset_panel_aria_label = /** @type {(inputs: Style_Guide_Reset_Panel_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de reinicialização`)
};

/**
* | output |
* | --- |
* | "Reset Panel" |
*
* @param {Style_Guide_Reset_Panel_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_reset_panel_aria_label = /** @type {((inputs?: Style_Guide_Reset_Panel_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Reset_Panel_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_reset_panel_aria_label(inputs)
	if (locale === "de") return de_style_guide_reset_panel_aria_label(inputs)
	if (locale === "it") return it_style_guide_reset_panel_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_reset_panel_aria_label(inputs)
	if (locale === "es") return es_style_guide_reset_panel_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_reset_panel_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_reset_panel_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_reset_panel_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_reset_panel_aria_label(inputs)
	return en_style_guide_reset_panel_aria_label(inputs)
});